"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switchify = exports.Buttonize = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var onKeyDown = function onKeyDown(props) {
  if (!(0, _isUndefined.default)(props.onClick)) {
    return function (e) {
      if (e.key === "Enter" || e.key === " ") {
        props.onClick(e);
        e.preventDefault();
      }
    };
  }

  return null;
};
/* <Buttonize> : Wrap layout items like <div>'s and <span>'s in order to turn them
** into buttons in a way that is compatible with screenreader applications
** Props:
**  label:string - The label assigned to the wrapped element. Will be read to
**      users by screenreader applications. Required.
**  onClick:func - Handler function, fires when wrapped element is clicked.
**      Takes an event object. Optional.
*/


var Buttonize = /*#__PURE__*/function (_React$Component) {
  _inherits(Buttonize, _React$Component);

  var _super = _createSuper(Buttonize);

  function Buttonize() {
    _classCallCheck(this, Buttonize);

    return _super.apply(this, arguments);
  }

  _createClass(Buttonize, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.cloneElement(_react.default.Children.only(this.props.children), {
        onClick: this.props.onClick,
        onKeyDown: onKeyDown(this.props),
        role: "button",
        tabIndex: 0,
        "aria-label": this.props.label,
        "aria-pressed": this.props.pressed
      });
    }
  }]);

  return Buttonize;
}(_react.default.Component);
/* <Switchify> : Wrap layout items like <div>'s and <span>'s in order to turn them
** into switches in a way that is compatible with screenreader applications
** Props:
**  label:string - The label assigned to the wrapped element. Will be read to
**      users by screenreader applications. Required.
**  onClick:func - Handler function, fires when wrapped element is clicked.
**      Takes an event object. Optional.
**  switchOn:bool - State of the switch; true indicates "on"
*/


exports.Buttonize = Buttonize;

_defineProperty(Buttonize, "propTypes", {
  label: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func,
  pressed: _propTypes.default.bool
});

var Switchify = /*#__PURE__*/function (_React$Component2) {
  _inherits(Switchify, _React$Component2);

  var _super2 = _createSuper(Switchify);

  function Switchify() {
    _classCallCheck(this, Switchify);

    return _super2.apply(this, arguments);
  }

  _createClass(Switchify, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.cloneElement(_react.default.Children.only(this.props.children), {
        onClick: this.props.onClick,
        onKeyDown: onKeyDown(this.props),
        role: "switch",
        "aria-checked": this.props.switchOn,
        tabIndex: 0,
        "aria-label": this.props.label,
        "aria-disabled": this.props.disabled
      });
    }
  }]);

  return Switchify;
}(_react.default.Component);

exports.Switchify = Switchify;

_defineProperty(Switchify, "propTypes", {
  label: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func,
  switchOn: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool
});